<script>
   import { onMount } from "svelte";

   import Boat from "./Boat.svelte";
   import Radar from "./Radar.svelte";

   export let port = "";
   export let postnr = "";
   let boats = [];
   let activity = [];

  onMount(async function() {
        const response = await fetch("/api/port/"+postnr+"/"+port);
       //  const response = await fetch("http://localhost:8080/api/port/4160/judaberg");
        const json = await response.json();
         boats = json.Boats;
         activity = json.Activity;
    });

   // Brukt flere steder
   function formatTime(time) {
      var t = new Date(time);
      var hours = t.getHours();
      var minutes = t.getMinutes();

      var year = t.getFullYear()
      if (year === 1) {
         return ""
      }
      var str = ""

      if (hours < 10) {
         str = str + "0" 
      }
      str = str + hours + ":" 

      if (minutes < 10) {
         str = str + "0" 
      }
      str = str + minutes 

      return str 
   }

   function rewriteText(str) {
      if (str === "exit") {
         return "forlot kai"
      }
      if (str === "enter") {
         return "ankom kai"
      }
   }

</script>

<div class="container">
  <div style="padding: 10px">
   <h1>{port}</h1>
  </div>
  <div class="row">
    <div class="col-sm boxCard">
      <h4>Båter i nærheten</h4>
         {#each boats as boat}
             <Boat boat={boat} />
         {/each}
    </div>
    <div class="col-sm boxCard">
      <h4>Radar</h4>
      <div class="svgcenter">
         <Radar boats={boats} />
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-sm boxCard">
      <h4>Aktivitet</h4>
      <div class="center">
         <table>
            <tr>
               <th>Tid</th>
               <th>Aktivitet</th>
            </tr>
         {#each activity as a}
            <tr>
               <td>{formatTime(a.Time)}</td>
               <td>{a.Name} {rewriteText(a.Text)}</td>
            </tr>
         {/each}
         </table>
      </div> 
    </div>
  </div>
</div>
<style>
   .boxCard {
      background-color: white;
      margin: 5px;
   }

   .svgcenter {
         display:flex;
         justify-content: center;
   }
   /* Mobil */
    .center {
    	margin: auto;
 		width: 100%;
      font-size: 2vw;
    }
    
   /* PC */
   @media (min-width : 770px) {
      .center {
         font-size: 1.2vw;
      }
   }

   table {
     margin: auto;
     font-family: arial, sans-serif;
     border-collapse: collapse;
     width: 100%;
   }

   th {
     padding: 8px;
   }
   
   td, th {
     border: 1px solid #dddddd;
     text-align: left;
   }
   
   tr:nth-child(even) {
     background-color: #dddddd;
   }
   h4 {
		text-align: center;
   }

	h1 {
		text-align: center;
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	body {
      background-color: #f1f3f5;
      width: 100%;
   }

</style>
